import { useEffect, useMemo, useRef, useState } from 'react'

import { Link } from 'features/i18n/router'
import { logEvent } from 'lib/analytics'
import { ROUTE_PATH } from 'lib/paths'

import Avatar from 'components/Avatar'
import { ActivityUser } from 'lib/_types'

import './style.scss'

type Props = {
  users?: ActivityUser[]
  resizeTrigger?: number
}

const AVATAR_SIZE = 34
const GAP_SIZE = 8

export const ActivityUserList = ({ users, resizeTrigger }: Props) => {
  const [isMount, setIsMount] = useState(false)
  const ref = useRef<HTMLUListElement>(null)

  useEffect(() => {
    setIsMount(true)
  }, [])

  const renderList = useMemo(() => {
    if (!ref.current || !isMount || !users) return []

    const width = ref.current.clientWidth

    const renderableCount = Math.floor(width / (AVATAR_SIZE + GAP_SIZE))

    if (users.length <= renderableCount) return users

    return [
      ...users.slice(0, renderableCount - 1),
      {
        id: 0,
        nickname: '',
        profile_icon_thumbnail: '/images/icon-more-users.svg',
      },
    ]
  }, [users, resizeTrigger, isMount])

  return (
    <ul
      className="ActivitiesList__item__ul"
      ref={ref}
      style={
        {
          '--gap-size': GAP_SIZE + 'px',
          '--avatar-size': AVATAR_SIZE + 'px',
        } as any
      }
    >
      {renderList.map((user, i) => (
        <li key={i}>
          <Link
            onClick={() => {
              if (user?.id)
                logEvent.user_profile_open({
                  target_user_id: user.id.toString(),
                  from: 'undefined',
                })
            }}
            to={user?.id ? ROUTE_PATH.USER(user?.id) : ''}
            className="ActivitiesList__item__ul__a"
          >
            <Avatar user={user} />
          </Link>
        </li>
      ))}
    </ul>
  )
}
